export default __webpack_public_path__ + "static/media/12.6404ee42.jpg";